import { HttpStatusCode, TyroPayRequestResponse } from './@types/pay-requests';
import { get3DSAuthRequest } from './3ds-auth';

export class ConnectPayClient {
  private paySecret: string;
  private baseUrl: string;

  constructor(paySecret: string) {
    this.paySecret = paySecret;
    this.baseUrl = `${process.env.CONNECT_PAY_BASE_URL}/pay/client`;
  }

  public async getPayRequest(): Promise<TyroPayRequestResponse> {
    const response = await fetch(this.url('/requests'), {
      method: 'GET',
      headers: this.headers(),
    });

    if (response.status !== HttpStatusCode.OK) {
      const error = await response.json();
      console.error('failed to get pay request:', error.errorCode);
      throw new Error(error.errorCode);
    }
    return response.json();
  }

  public async send3DSecureAuthRequest(): Promise<Response> {
    return fetch(this.url('/3dsecure/auth'), {
      method: 'POST',
      headers: this.headers(),
      body: JSON.stringify(get3DSAuthRequest()),
    });
  }

  private url = (path: string): string => `${this.baseUrl}${path}`;

  private headers = (): Record<string, string> => ({
    'Content-Type': 'application/json',
    'Pay-Secret': this.paySecret,
  });
}
